import * as React from 'react';

interface IProps {
    className?: string;
}

class UseCaseOutcomeDesktop extends React.Component<IProps> {
    public render() {
        return (
            <svg viewBox="0 0 350 416" fill="none" xmlns="http://www.w3.org/2000/svg" className={this.props.className}>
                <g clipPath="url(#useCaseOutsomeClip0)">
                    <rect y="1.33691" width="350" height="415" rx="30" fill="#031629" />
                    <rect x="162.5" y="148.337" width="67" height="38" rx="19" fill="#023150" />
                    <path
                        d="M195.439 159.169L184.801 169.01C183.465 170.246 184.339 172.478 186.159 172.478L206.253 172.478C208.016 172.478 208.917 170.364 207.695 169.093L198.24 159.251C197.485 158.465 196.239 158.429 195.439 159.169Z"
                        fill="#039BE5"
                    />
                    <path d="M351.174 230.257C286.179 352.349 102.129 355.387 -0.525391 352.957L-0.162581 417.64H351.174L351.174 230.257Z" fill="url(#paint0_linear)" />
                    <path d="M-0.525391 352.957C102.129 355.387 286.179 352.349 351.174 230.257" stroke="#039BE5" strokeWidth="3" />
                    <circle cx="-0.524523" cy="353.41" r="6.94227" fill="#039BE5" />
                    <circle cx="350.001" cy="231.031" r="6.94227" fill="#039BE5" />
                </g>
                <defs>
                    <linearGradient id="paint0_linear" x1="175.324" y1="197.027" x2="175.324" y2="399.078" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#039BE5" />
                        <stop offset="1" stopColor="#039BE5" stopOpacity="0" />
                    </linearGradient>
                    <clipPath id="useCaseOutsomeClip0">
                        <rect y="0.904785" width="350" height="415" rx="30" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        );
    }
}

export default UseCaseOutcomeDesktop;
